const analyzeHttpResult = httpResult => {
    // If there is no content (http 204/202/304) from the server, skip.
    if (!httpResult || httpResult === 'Accepted - No Content') {
        return [];
    }
    const items = httpResult.items || httpResult; // handle old and new api.
    if (!Array.isArray(items)) {
        throw new Error(
            `The lookup result from the server is in an unexpected format. Expected an array or an object with an 'items' array, but got: ${JSON.stringify(httpResult)}`
        );
    }
    return items;
};

export default analyzeHttpResult;
